/**
 * The ink tint for a cover hue — for callers overlaying text or glyphs on a
 * `GeneratedCover` plate. Lives apart from the component so both can be
 * imported without tripping fast refresh.
 *
 * `hue` is whatever `GeneratedCover` was given: an angle (`'199'`) or a token
 * reference (`'var(--cover-hue-3)'`).
 */
export const coverInk = (hue: string) => `hsl(${hue} var(--cover-ink))`;
